var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"audio-player-box"},[_c('h3',{staticClass:"audio-player-h3"},[_c('i',{staticClass:"el-icon-circle-close audio-player-icon",on:{"click":function($event){return _vm.audioClose('close')}}})]),_c('audio',{staticClass:"u-audio",attrs:{"src":_vm.audioUrl,"autoplay":"","controls":""}},[_vm._v(" 您的浏览器版本过低，暂不支持音频播放，请升级或更换浏览器。 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }